//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setOwnKey, COLUMN_SETTINGS } from '@/tools'
import ItemSetting from '../ItemSettings.vue'
import { mapGetters } from 'vuex'
export default {
  props: {
    question: {
      type: Object,
      default: {
        v_ownId: setOwnKey(),
        v_active: false,
        v_label: '多选题',
        type: 'checkbox',
        displayIndex: true,
        title: '请选择以下选项 (多选)',
        required: true,
        voteVisible: false,
        selectRangeMin: 0,
        selectRangeMax: 0,
        scoreType: '1',
        scoreTotal: 0,
        column: 1,
        uploadArrow: true,
        uploadArrowRequired: false,
        logic: {
          blocks: {
            typeBlock: 'all',
            list: [],
          },
        },
      },
    },
  },
  filters: {
    setting(value) {
      return value ? COLUMN_SETTINGS[value] : ''
    }
  },
  computed: {
    ...mapGetters(['columnSetting']),
  },
  data() {
    return {
      limitList: [],
      limitObj: {},
    }
  },
  created() {
    this.processLen()
  },
  methods: {
    change() {
      this.$emit('update:item', this.item)
    },
    processLimit(value) {
      return value ? this.limitObj[value] : '不限'
    },
    // 处理长度
    processLen() {
      let len = this.question.options.length + 1
      let arr = []
      let curObj = {}
      for (let i = 0; i < len; i++) {
        let obj = { text: `${i}项`, value: i }
        if (i == 0) {
          obj.text = '不限'
        }
        curObj[i] = obj.text
        arr.push(obj)
      }
      this.limitList = arr
      this.limitObj = curObj
    },
    //布局排列
    columnSettings() {
      new this.$Picker({
        data: [this.columnSetting],
        value: [this.question.column],
        onOk: (values, text, selectedIndex) => {
          this.question.column = values[0]
        },
      })
    },
    //可选范围
    selectRange(type) {
      this.processLen()
      new this.$Picker({
        data: [this.limitList],
        onOk: (value, text, selectedIndex) => {
          let values = value[0]
          if (type == 'selectRangeMin') {
            let min = Number(values)
            let max = Number(this.question.selectRangeMax)
            if (min > max) {
              this.question.selectRangeMax = 0
            }
          } else {
            let min = Number(this.question.selectRangeMin)
            let max = Number(values)
            if (min > max) {
              this.question.selectRangeMin = 0
            }
          }
          this.question[type] = values
        },
      })
    },
    //分值设置
    scoreSettings() {
      let _this = this
      let popup = new this.$Popup(ItemSetting, {
        position: 'bottom',
        isMaskClose: true,
        size: '100%',
        question: _this.question,
        onchoose(item) {
          popup.close()
        },
      })
    },
  },
}
